import { styled } from '@linaria/react';
import { useAvivaSelector } from '@redux/hook';
import { Helpers } from '@utils/helpers';
import { ceil, debounce } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ITheme } from 'src/theme';
import Input from '../Input';
import { css } from '@linaria/core';
import successTick from "@assets/icon/green-round-tick.svg";

const LimitLabel = styled.p`
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.8;
`;

const SliderLimit = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const SliderInputRange = styled.input`
  -webkit-appearance: none;
  margin-right: 15px;
  width: 100%;
  height: 8px;
  background: #fafafa;
  border-radius: 5px;
  background-image: linear-gradient(#dfc2dd, #dfc2dd);
  background-size: 0% 100%;
  background-repeat: no-repeat;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 31px;
    width: 31px;
    border-radius: 50%;
    background: #883e89;
    cursor: ew-resize;
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
  }
  &::-moz-range-thumb {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #883e89;
    cursor: ew-resize;
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
  }
  &::-ms-thumb {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #883e89;
    cursor: ew-resize;
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
  }
  &::-webkit-slider-thumb:hover {
    background: #883e89;
  }
  &::-moz-range-thumb:hover {
    background: #883e89;
  }
  &::-ms-thumb:hover {
    background: #883e89;
  }
  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
  &::-moz-range-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
  &::-ms-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
`;

const SliderLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #b474b0;
  text-align: center;
`;

const SliderInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const existingCss = css`
  font-weight: 400;
`;
const addOnCss  = css`
  font-weight: 600; 
`;

const existingAndAddonCss  = css`
  font-size: 14px;
  color: #883E89;  
  margin: -8px auto 16px auto;
`;

export interface SliderInputProps {
  min: number;
  max: number;
  theme: ITheme;
  step?: number;
  onChange?:(e:any)=>void;
  onBlur?:(e:any)=>void;
  disabled?:boolean;
  initialValue?:number;
  validQRClient?: boolean;
  existingMonthlyBenefit?: number;
  tickEnabled?: boolean;
}

const SliderInput = ({ min, max,onChange,onBlur,step=100,disabled=false,validQRClient,existingMonthlyBenefit,tickEnabled,initialValue,...props }: SliderInputProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [currencyFormated, setCurrencyFormated] = useState(Helpers.toCurrency(0));
  const sliderRef = useRef(null);

  const initAmount = initialValue;
  useEffect(()=>{
    console.log("slider input value",initAmount);
    setInputValue(Helpers.toCurrency(min));
    setCurrencyFormated(`${Helpers.toCurrency(min)}`);
    if(initAmount)
    {
      setInputValue(Helpers.toCurrency(initAmount));
      setCurrencyFormated(`${Helpers.toCurrency(initAmount)}`);
      sliderOnInput(sliderRef,min,max,initAmount);
    }
  },[initAmount, max, min])

  useEffect(() => {
    if (onChange && initAmount) {
      onChange(initAmount);
    }
    if (onBlur && initAmount) {
      onBlur(initAmount);
    }
  }, []);

  const formatCurrency = (value: number) => {
    let tempValue:number = value;
    // setInputValue(Helpers.toCurrency(tempValue));
    setCurrencyFormated(`${Helpers.toCurrency(tempValue)}`);
    sliderOnInput(sliderRef,min,max,amountValidation(tempValue));
  };

  const sliderInputOnBlur = (value: number) =>{

    //Validate amount and rounded to hundreds when on blur
    let tempValue:number = amountValidation(value);
    console.log("sliderInputOnBlur",{value,tempValue});
    
    setIsEditing(false);
    setInputValue(Helpers.toCurrency(tempValue));
    setCurrencyFormated(`${Helpers.toCurrency(tempValue)}`);
    sliderOnInput(sliderRef,min,max,tempValue);
    if(onChange)
    {
      onChange(tempValue);
    }
    if(onBlur)
    {
      onBlur(tempValue);
    }
  }
  
  const amountValidation = (value:number):number =>{
    if(value < min)
    {
      return min;
    }
    else if(value > max)
    {
      return max;
    }
    else{
      let ceilValue = ceil(value / 100) * 100;
      return ceilValue;
    }
  }

  const sliderInputChange = (target: any) => {
    const min = target.min;
    const max = target.max;
    const value = parseInt(target.value);
    console.log("🚀 ~ file: SliderInput.tsx ~ line 175 ~ sliderInputChange ~ value", value)

    
    target.style.backgroundSize =
      ((value - min) * 100) / (max - min) + '% 100%';
    setInputValue(Helpers.toCurrency(value));
    setCurrencyFormated(`${Helpers.toCurrency(value)}`);
    
  };

  const sliderOnInput = (target: any,min:number,max:number,value:number) => {    
    target.current.style.backgroundSize = value ? ((value - min) * 100) / (max - min) + '% 100%' : 0; 
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currencyValue = +(e.target.value.replace(/\D/g, ""))/100;
    setInputValue(e.target.value);
    formatCurrency(currencyValue);
  }

  const currencyMask = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    // value = value.replace(/(\d)(\d{2})$/g, "$1. $2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ",");
    value = `S$${value}`
    e.target.value = value;
    return e;
  }
  return (
    <SliderInputContainer>
      <SliderLabel htmlFor="">
        <div style={{ display: "flex", justifyContent: "center" }}>
          {validQRClient ? "Total Monthly Benefit" : "Monthly Benefit"}
          {validQRClient && tickEnabled && (
            <img
              src={successTick}
              style={{ marginLeft: "0.5rem" }}
              width={24}
              height={24}
              alt="icon-img"
            />
          )}
        </div>
      </SliderLabel>
      {isEditing ? (
        <Input
          textAlign="center"
          variant="slider"
          margin={"0 auto 16px auto"}
          type="normal"
          value={inputValue.replace(".00", "")}
          // onChange={(e) => formatCurrency(e.target.value)}
          onBlur={(e) => sliderInputOnBlur(+e.target.value.replace(/\D/g, ""))}
          onChange={(e) => handleChange(currencyMask(e))}
        />
      ) : (
        <Input
          textAlign="center"
          variant="slider"
          margin={"0 auto 16px auto"}
          readOnly={disabled}
          value={currencyFormated.replace(".00", "")}
          onFocus={() => (disabled ? setIsEditing(false) : setIsEditing(true))}
        />
      )}
      {validQRClient && (
        <div className={existingAndAddonCss}>
          <span className={existingCss}>
            {Helpers.toCurrencyND(existingMonthlyBenefit ?? 0)}(existing)
          </span>{" "}
          <span className={addOnCss}>
            + {Helpers.toCurrencyND((initAmount ?? 0) - (existingMonthlyBenefit ?? 0))} (add-on)
          </span>
        </div>
      )}
      <SliderLimit>
        <LimitLabel>{Helpers.toCurrencyND(min)}</LimitLabel>
        <LimitLabel>{Helpers.toCurrencyND(max)}</LimitLabel>
      </SliderLimit>
      <SliderInputRange
        disabled={disabled}
        step={step}
        ref={sliderRef}
        type="range"
        name="points"
        value={+inputValue.replace(/\D/g, "") / 100}
        min={min}
        max={max}
        onChange={(e) => sliderInputChange(e.target)}
        onMouseUp={(e: any) => {
          const value = parseInt(e.target.value);
          console.log("on mouse up", value);
          if (onChange) {
            onChange(value);
          }
          if (onBlur) {
            onBlur(value);
          }
        }}
        onTouchEnd={(e: any) => {
          const value = parseInt(e.target.value);

          console.log("on touch end", value);
          if (onChange) {
            onChange(value);
          }
          if (onBlur) {
            onBlur(value);
          }
        }}
      ></SliderInputRange>
    </SliderInputContainer>
  );
};

SliderInput.defaultProps = {
  min: 0,
  max: 1000,
};

export { SliderInput };